import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { keyBy } from "lodash";
import { DynamicDataObk, Graph_QL } from "../..";
import { System } from "./GQLCalls/getSystemCall";



export type SystemItem = DynamicDataObk<System[]>

const systemsDataAdapter = createEntityAdapter({
  selectId: (item: SystemItem) => Graph_QL.ObjToString(item.con)
});

const replaceStateWithPayload = (state: EntityState<SystemItem, string>, { con, data }: SystemItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const dataDictionary = keyBy(state.entities[identifier].data, "system_id")
    data.forEach((entry) => dataDictionary[entry.system_id] = entry)
    const newPayload = { con, data: Object.values(dataDictionary) }
    systemsDataAdapter.upsertOne(state, newPayload);
  } else { systemsDataAdapter.addOne(state, { con, data }) }
}

const mergePayloadAndState = (state: EntityState<SystemItem, string>, { con, data }: SystemItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const dataDictionary = keyBy(state.entities[identifier].data, "system_id")
    data.forEach((entry) => dataDictionary[entry.system_id] = { ...dataDictionary[entry.system_id], ...entry })
    const newPayload = { con, data: Object.values(dataDictionary) }
    systemsDataAdapter.upsertOne(state, newPayload);
  } else { systemsDataAdapter.addOne(state, { con, data }) }
}

const systemsSlice = createSlice({
  name: "systems",
  initialState: systemsDataAdapter.getInitialState(),
  reducers: {
    maintained: (state, { payload }: PayloadAction<SystemItem>) => {
      replaceStateWithPayload(state, payload);
    },
    merged: (state, { payload }: PayloadAction<SystemItem>) => {
      mergePayloadAndState(state, payload);
    }
  }
})

export const SystemActions = systemsSlice.actions;
export default systemsSlice.reducer;
